import BillboardLocation from "../../../components/BillboardLocation";
import BillboardDetailPriceDetail from "./BillboardDetailPriceDetail";
import { isMobileRes, dateToString, stringToDate, correctDateRange, numberDaysByDateRange, GTMEvent } from "../../../utils/Utils";
import BillboardDetailMenu from "./BillboardDetailMenu";
import * as skrollTop from 'skrolltop';
import BillboardDetailImage from "./BillboardDetailImage";
import BillboardDetailPriceChart from "./BillboardDetailPriceChart";
import Billboards from "../../../libs/API/Billboards";
import ShoppingCart from "../../../components/shopping-cart/ShoppingCart";
import Alert from "../../../components/Alert";
import BillboardCalendar from "../../../components/BillboardCalendar";
import Auth from "../../../libs/API/Auth";
import BillboardDetailPriceStatic from "./BillboardDetailPriceStatic";

 
class BillboardDetail{
    constructor(){
        this.main = document.getElementById('billboard_detail');
        
        this._billboardData = JSON.parse(this.main.getAttribute('data-billboard'));
        
        this._menu = new BillboardDetailMenu();

        this._image = new BillboardDetailImage(this._billboardData.id, this._billboardData.artwork_preview);
        this._priceChart = new BillboardDetailPriceChart();
        this._priceDetail = new BillboardDetailPriceDetail(this._billboardData.format.id, this._billboardData.id, this._billboardData.name);
        this._priceDetailStatic = new BillboardDetailPriceStatic();
        this._location = new BillboardLocation('billboard_detail_location', this._billboardData.lat, this._billboardData.lng, this._billboardData.places);        

        this._billboardId = this._billboardData.id;
        this._billboardSlug = this._billboardData.slug;
        this._isStatic = [Billboards.FORMAT_STATIC, Billboards.FORMAT_OTHER_MEDIA].includes(this._billboardData.format.id);
        this._dateRange = null;
        this._brandId = null;
        this._brandCategoryId = null;
        this._exclusivity = false;
        this._weekdays = null;

        this._contentsHolder = this.main.querySelector('.contents_holder');
        this._contents = Array.from(this.main.querySelectorAll('.content'));

        this._isMobileRes = false;

        this._onResize();
        
        window.addEventListener('resize', this._onResize.bind(this));
        window.addEventListener('scroll', this._onScroll.bind(this));

        this._menu.addEventListener('clickBtn', this._onClickMenuBtn.bind(this));
        let params = new URLSearchParams(window.location.search);

        if (params.has('order_id')) {
            this._priceDetailStatic.show();
        } else {
            this._priceDetail.show();
            this._priceDetail.addEventListener('filterChanged', this._onPriceDetailFilterChanged.bind(this));
            this._priceDetail.addEventListener('showDatesAvailable', this._onShowDatesAvailable.bind(this));
            this._priceDetail.addEventListener('addToList', this._onAddToList.bind(this));
        }

        window.addEventListener('popstate', this._onPopState.bind(this));

        Auth.addEventListener('sessionReady', this._onSessionReady.bind(this));
    }
    
    _onSessionReady(){
        this._parseURL();
        GTMEvent('view_item', {
            ecommerce: {
                currency: "USD",
                value: this._billboardData.price,
                items: [
                {
                    item_id: this._billboardData.id,
                    item_name: this._billboardData.name,
                }]
            }
        });
        if(ShoppingCart.isReady){
            this._onShoppingCartReady();
        }else{
            ShoppingCart.addEventListener('cartReady', this._onShoppingCartReady.bind(this));
        }
    }

    _onResize(e){
        let isMobile = isMobileRes();
        
        // CAMBIO A PRICE DETAIL DE HOLDER SEGÚN LA RESOLUCIÓN
        // Cambió a mobile
        if(!this._isMobileRes && isMobile){
            this._isMobileRes = true;
            
            this.main.querySelector('.price_detail_holder_mobile').appendChild(this._priceDetail.main);
            this.main.querySelector('.price_detail_holder_mobile').appendChild(this._priceDetailStatic.main);
        }

        // Cambió a desktop
        if(this._isMobileRes && !isMobile){
            this._isMobileRes = false;
            this.main.querySelector('.price_detail_holder_desktop').appendChild(this._priceDetail.main);
            this.main.querySelector('.price_detail_holder_desktop').appendChild(this._priceDetailStatic.main);
        }
    }

    _onScroll(e){
        let currentContentIndex = -1;
        
        for(let i=this._contents.length - 1; i >= 0; i--){
            let diff; 
            
            if(i == this._contents.length - 1){// Location está por fuera del holder
                diff = window.pageYOffset - this._contents[i].offsetTop + 100;    
            }else{
                diff = window.pageYOffset - this._contents[i].offsetTop - 20   
            }


            if(diff > 0){
                currentContentIndex = i;
                break;
            }
        }
        
        this._menu.set(currentContentIndex);        

    }
    

    _onClickMenuBtn(e){
        let index = e.detail.index;
        let to;
        // Location es especial porque está por fuera del holder
        if(index == this._contents.length - 1){
            to = this._contents[index].offsetTop - 100;  
        }else{
            to = this._contents[index].offsetTop + 80  
        }

        
        skrollTop.scrollTo({
            element: window,
            to: to,
            duration: 600
        });
    }

    _onPriceDetailFilterChanged(e){
        this._getData(e.detail.dateRange, e.detail.brandId, e.detail.brandCategoryId, e.detail.exclusivity, true, e.detail.weekdays);
    }

    _onPopState(e){
        this._parseURL(false);
    } 

    _parseURL(updateURL = true){
        let params = new URLSearchParams(window.location.search);
        
        // Date Range
        let dateRange = null;
        
        if(params.has('date_range')){
            let dateRangeArray = params.get('date_range').split(',');
            
            if(dateRangeArray.length == 2){
               dateRange = {from: stringToDate(dateRangeArray[0]), to: stringToDate(dateRangeArray[1])};
            }
        }

        if(params.has('day_selected') && this._priceDetail.dateRangePicker){
            let daysSelectedArray = params.get('day_selected') ? params.get('day_selected').split(',') : [];
            if(daysSelectedArray.length >= 1){
                this._priceDetail.dateRangePicker.daysSelected = daysSelectedArray;
            }
        }

        let orderId = params.has('order_id') ? params.get('order_id') : null;
        if (orderId == null) {
            dateRange = correctDateRange(dateRange);
        }
        let weekdays = params.has('day_selected') && params.get('day_selected') ? params.get('day_selected').split(',') : null;
        let brandId = params.has('brand_id') && (Auth.isCustomerLogged || Auth.isExternalSellerLogged) ? params.get('brand_id') : null;
        let brandCategoryId = params.has('brand_category_id') && !(Auth.isCustomerLogged || Auth.isExternalSellerLogged) ? params.get('brand_category_id') : null;
        let exclusivity = params.has('exclusivity') && params.get('exclusivity') == 'true' && !this._isStatic ? true : false;

        this._priceDetail.dateRange = Object.assign({}, (dateRange));
        this._priceDetail.weekdays = weekdays;
        this._priceDetail.brandId = brandId; 
        this._priceDetail.brandCategoryId = brandCategoryId;
        this._priceDetail.exclusivity = exclusivity;
        
        this._getData(dateRange, brandId, brandCategoryId, exclusivity, updateURL, weekdays, orderId);
    }

    _getData(dateRange, brandId, brandCategoryId, exclusivity, updateURL = true, weekdays = null, orderId = null){
        if (!this._isValidDateRange()) {
            this._priceDetail.addToListDisabled = true;
            this.main.classList.add('skeleton--show');
            Alert.show('warning', 'Warning', 'Static billboards can only be booked for a minimum of 30 days.');
            return;
        }
        
        if(this._isStatic){
            exclusivity = false;
        }
        
        this._dateRange = dateRange;
        this._brandId = brandId;
        this._brandCategoryId = brandCategoryId;
        
        this._exclusivity = exclusivity;
        this._weekdays = weekdays;
        
        let fields = ['id','price','days_available','cpm','dates_available','visibility'];

        if(updateURL){
            let url = `${BASE_URL}billboards/${this._billboardSlug}?date_range=${dateToString(dateRange.from)},${dateToString(dateRange.to)}`;

            if(weekdays != null){
                url += `&day_selected=${weekdays.join(',')}`;
            }

            if(brandId != null){
                url += `&brand_id=${brandId}`;
            }

            if(brandCategoryId != null){
                url += `&brand_category_id=${brandCategoryId}`;
            }

            if(exclusivity){
                url += `&exclusivity=true`;
            }

            if (orderId){
                url += `&order_id=${orderId}`;
            }

            window.history.pushState({},null, url );
        }
        
        this.main.classList.add('skeleton--show');

        
        this._checkAddToList();
        

        if (orderId) {
            this._priceChart.set(
                this._priceDetailStatic._dateRange,
                this._priceDetailStatic._datesAvailable,
                this._priceDetailStatic._price / this._priceDetailStatic._daysAvailable
            );

            this.main.classList.remove('skeleton--show');
        } else {
            Billboards.getBillboardById(this._billboardId, fields, dateRange, exclusivity, brandId, brandCategoryId, weekdays).then((data)=>{
                this.main.classList.remove('skeleton--show');
                this._priceDetail.set(data.price, data.cpm, data.days_available, data.visibility);
                this._priceChart.set(this._dateRange, data.dates_available, data.price/data.days_available);
            });
        }
    }

    /* _onNavPriceChart(e){
        let to = this._priceChart.main.offsetTop + 80;
        
        skrollTop.scrollTo({
            element: window,
            to: to,
            duration: 600
        });
    } */

    _onShowDatesAvailable(e){
        BillboardCalendar.showAvailability(this._billboardId, this._dateRange, this._exclusivity, this._brandId, this._brandCategoryId, this._weekdays);
    }

    _onAddToList(e){
        ShoppingCart.add(this._billboardId, this._dateRange, this._exclusivity, this._brandId, this._brandCategoryId, this._weekdays).then(function () {
            ShoppingCart._loadList();
        });
    }

    _onShoppingCartReady(e){
        ShoppingCart.addEventListener('cartChange', this._onShoppingCartChange.bind(this));

        this._checkAddToList();
    }

    _onShoppingCartChange(e){
        this._checkAddToList();
    }

    _checkAddToList(){
        if(ShoppingCart.isReady){
            let addedToList = ShoppingCart.data.items.filter(item => {  
                
                let sameId = item.id == this._billboardId;
                let sameBrandId = item.brand_id == this._brandId;
                let sameBrandCategoryId = item.brand_category_id == this._brandCategoryId;
                let sameDateRange = item.dateRange.from.getTime() == this._dateRange.from.getTime() && item.dateRange.to.getTime() == this._dateRange.to.getTime()
                let sameExclusivity = item.exclusivity == this._exclusivity;
                
                return sameId && sameBrandId && sameBrandCategoryId && sameDateRange && sameExclusivity;
    
            }).length > 0;
            this._priceDetail.addedToList = addedToList;

            if (!this._isValidDateRange()) {
                this._priceDetail.addToListDisabled = true;
            }
        }        
    }

    _isValidDateRange() {
        let numberDays = numberDaysByDateRange(this._priceDetail.dateRangePicker.dateRange) + 1;
        if(this._isStatic && numberDays < Billboards.STATIC_MIN_DAYS_RANGE){
            return false;
        }

        return true;
    }
}

export default BillboardDetail;